import React, {useEffect, useRef, useState} from 'react';

const TrophyScalingWrapper = ({children, order}) => {
    const containerRef = useRef(null);
    const [scale, setScale] = useState(1);
    const resizeObserverRef = useRef(null);
    const [baseWidth, setBaseWidth] = useState(40);

    useEffect(() => {
        if (!containerRef.current || !containerRef.current.parentElement) {
            return;
        }

        const updateScale = () => {
            if (!containerRef.current || !containerRef.current.parentElement) {
                return;
            }
            const parentWidth = containerRef.current.parentElement.offsetWidth;
            const newScale = parentWidth / baseWidth;
            setScale(newScale);
        };

        updateScale();

        // Store observer in a ref to clean it up correctly
        const observerRef = resizeObserverRef.current;
        if (observerRef) {
            observerRef.disconnect(); // Properly clean up previous observer before creating a new one
        }

        const resizeObserver = new ResizeObserver(updateScale);
        resizeObserver.observe(containerRef.current.parentElement);
        resizeObserverRef.current = resizeObserver; // Save reference

        return () => {
            if (resizeObserverRef.current) {
                resizeObserverRef.current.disconnect(); // Cleanup on unmount or re-run
            }
        };
    }, [baseWidth]);

    return (
        <div
            ref={containerRef}
            style={{
                transform: `scale(${scale})`,
                transformOrigin: '0 0',
                width: `${baseWidth}px`,
            }}
        >
            {children}
        </div>
    );
};

export default TrophyScalingWrapper;